import { defaultApi } from '@/plugins/api/defaultApi'
import moment from 'moment'

const defaultState = function () {
  const accounts = null
  const isEarlyPaymentsLoading = false
  const isRefundsLoading = false
  const isSalesSummaryLoading = false

  const isNewEarlypaymentsLoading = false

  const earlyPayments = null

  const newEarlypayments = null

  const refunds = []
  const salesSummary = {}

  return {
    accounts,
    isEarlyPaymentsLoading,
    isRefundsLoading,
    isSalesSummaryLoading,
    earlyPayments,
    refunds,
    salesSummary,

    isNewEarlypaymentsLoading,
    newEarlypayments,
  }
}

export default {
  name: 'earlyPayment',
  namespaced: true,
  state: defaultState(),
  getters: {
    getEarlyPaymentsLoading(state) {
      return state.isEarlyPaymentsLoading
    },
    getEarlyPayments(state) {
      return state.earlyPayments
    },
    getRefundsLoading(state) {
      return state.isRefundsLoading
    },
    getRefunds(state) {
      return state.refunds
    },
    getSalesSummaryLoading(state) {
      return state.isSalesSummaryLoading
    },
    getSalesSummary(state) {
      return state.salesSummary
    },
    getNewEarlyPaymentsLoading(state) {
      return state.isNewEarlypaymentsLoading
    },
  },
  mutations: {
    setAccounts(state, accounts) {
      state.accounts = accounts
    },
    setEarlyPaymentsLoading(state, flag) {
      state.isEarlyPaymentsLoading = flag
    },
    setEarlyPayments(state, v) {
      state.earlyPayments = v
    },
    setRefundsLoading(state, flag) {
      state.isRefundsLoading = flag
    },
    setRefunds(state, v) {
      state.refunds = v
    },
    setSalesSummaryLoading(state, flag) {
      state.isSalesSummaryLoading = flag
    },
    setSalesSummary(state, v) {
      state.salesSummary = v
    },
    setNewEarlyPaymentsLoading(state, flag) {
      state.isNewEarlypaymentsLoading = flag
    },
    setNewEarlyPayments(state, v) {
      state.newEarlypayments = v
    },
  },
  actions: {
    async getEarlyPayments({ commit, getters }, date) {
      const isLoading = getters.getEarlyPaymentsLoading
      if (isLoading) {
        return
      }
      try {
        commit('setEarlyPaymentsLoading', true)
        const { data } = await defaultApi.getEarlyPayments({ date })
        commit('setEarlyPayments', data)
        return data
      } finally {
        commit('setEarlyPaymentsLoading', false)
      }
    },
    async getRefunds({ commit, getters }, date) {
      const isLoading = getters.getRefundsLoading
      if (isLoading) {
        return
      }
      commit('setRefundsLoading', true)

      let result = []
      try {
        const q = { created__date: date }
        const { data } = await defaultApi.getRefunds(q)
        result = data || []
      } finally {
        commit('setRefunds', result)
        commit('setRefundsLoading', false)
      }
    },
    async getSalesSummary({ commit, getters }, date) {
      const isLoading = getters.getSalesSummaryLoading
      if (isLoading) {
        return
      }
      const summary = getters.getSalesSummary
      if (summary?.[date]) {
        return
      }

      commit('setSalesSummaryLoading', true)
      const result = { ...summary }
      try {
        const { data } = await defaultApi.getSalesSummary({ date })
        if (data) {
          result[date] = data
        }
      } finally {
        commit('setSalesSummary', result)
        commit('setSalesSummaryLoading', false)
      }
    },
    async getNewEarlyPayments({ commit, getters }, date) {
      const isLoading = getters.getNewEarlyPaymentsLoading
      if (isLoading) {
        return
      }

      let result = []
      try {
        commit('setNewEarlyPaymentsLoading', true)
        const { data } = await defaultApi.getNewEarlyPayments({ date })
        result = data
        return result
      } finally {
        commit('setNewEarlyPayments', result)
        commit('setNewEarlyPaymentsLoading', false)
      }
    },
    async getCardDeliveryDeposits({ commit, getters },date) {
      let result = null
      const { data } = await defaultApi.getCardDeliveryDeposits({ date })
      result = data
      return result
    },
    async getDailyAmount({}, query) {
      let result = null

      const { data } = await defaultApi.getDailyAmount(query)
      result = data
      return result
    },
    async getSalesDailyTotal({}, query) {
      let result = null
      const { data } = await defaultApi.getSalesDailyTotal(query)
      result = data
      return result
    },
    async addEarlyPaymentsLoanRequests({}) {
      let result = null
      const { data } = await defaultApi.postEarlyPaymentsLoanRequests()
      result = data
      return result
    },
    async addEarlyPaymentsCallbackRequests({}, params) {
      const { data } = await defaultApi.postEarlyPaymentsCallbackRequests(params)
      return data
    },
  },
}
